// extracted by mini-css-extract-plugin
module.exports = {"container":"CategorySection-module--container--3aWPR","heading":"CategorySection-module--heading--18OGq","cardsContainer":"CategorySection-module--cardsContainer--1j5FG"};